function PageNotFound(){
    return <h1>Error404</h1>
}

export default PageNotFound;